import React from 'react';
import ReactSelect from 'react-select';
import {ValueType} from 'react-select/lib/types';

import {select} from '../styles';
import {Label} from 'components/ultra';

import {PosterVariant} from 'gql/types';

interface Option {
  value: PosterVariant;
  label: string;
}

interface SelectProps {
  options: PosterVariant[];
  value: PosterVariant;
  onChange(value: PosterVariant): void;
}

export function PosterVariantSelect({options, value, onChange}: SelectProps) {
  const formattedOptions = options.map(option => ({
    value: option,
    label: option.toLowerCase(),
  }));

  const formattedValue = value
    ? {value: value, label: value.toLowerCase()}
    : formattedOptions[0];

  // Guard for making sure it is not an Array but an object of type Option
  const isOption = (option: any): option is Option =>
    option.value !== undefined && option.label !== undefined;

  const handleChange = (option: ValueType<Option>) => {
    if (isOption(option)) {
      onChange(option.value);
    }
  };

  return (
    <>
      <Label>Poster design</Label>
      <ReactSelect
        styles={select}
        onChange={handleChange}
        options={formattedOptions}
        placeholder="Select poster type"
        value={formattedValue}
      />
    </>
  );
}
